import { IAPIRoutes } from "../../../../config";

export type ISearchRepository = ReturnType<typeof SearchRepositoryFactory>;

export const SearchRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getSearchAPI: IGetSearchAPI = async (payload) =>
    GET(
      APIRoutes.apiGetSearch.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getAllPatientListAPI: IGetAllPatientListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetAllPatientList.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getAllPatientListV2API: IGetAllPatientListV2API = async (payload) =>
    GET(
      APIRoutes.apiGetAllPatientListV2.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getSearchAPI,
    getAllPatientListAPI,
    getAllPatientListV2API,
  };
};
